

































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DemoRoster from "@/admin/components/demo-config/DemoRoster.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDemoUsersStore } from "@/admin/store/demoUsers";

@Component({
  components: {
    GenericLoadingSpinner,
    DemoRoster,
  }
})
export default class DemoConfigPage extends Vue {
  featureFlagStore = useFeatureFlagStore();
  demoUserStore = useDemoUsersStore();

  mounted () {
    if (this.featureFlagIsOn) {
      this.demoUserStore.loadRosters();
    }
  }

  get isLoaded () {
    return this.demoUserStore.areRostersLoaded;
  }

  get featureFlagIsOn (): boolean {
    return this.featureFlagStore.flags.UseDemoDataInjectionTableForDrivewealthMocks;
  }
}

